/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ClientUserDto { 
    id?: number;
    emailAddress?: string | null;
    countryCode: string;
    phoneNumber: string;
    fullName?: string | null;
    dob?: string | null;
    currentResidenceAddress?: string | null;
    lastResidenceAddress?: string | null;
    fatherName?: string | null;
    age?: number | null;
    dateOfJoining?: string | null;
    referenceNumber?: string | null;
    nationalIdNumber?: string | null;
    taxNumber?: string | null;
    isMarried?: boolean | null;
    spouseName?: string | null;
    currentPlaceOfEmployment?: string | null;
    lastPlaceOfEmployment?: string | null;
    isLastPlaceOfEmploymentIsSameAsOfCurrent?: boolean | null;
    isLastResidenceAddressIsSameAsOfCurrent?: boolean | null;
    isActive?: boolean;
    gender?: string | null;
    branchId?: number | null;
    maritalStatusId?: number | null;
    memberTypeId?: number | null;
    policyId?: number | null;
    relationshipManagerId?: number | null;
    groupId?: number | null;
    surname?: string | null;
    middleName?: string | null;
    name?: string | null;
}

